// src/components/Pat/patSectorIntel.js

import { supabase } from "../../utils/supabaseClient";
import { normalizeSectorName } from "../../utils/normalizeSectorName";

// -------------------------------------------------------
// EXTRACT A SECTOR FROM A QUESTION
// -------------------------------------------------------

export function extractSectorFromQuestion(question) {
  const text = String(question || "")
    .toUpperCase()
    .replace(/\s+/g, " ")
    .trim();

  /*
   * Matches outward postcode / sector-style values such as:
   *
   * PR4
   * FY8
   * FY4
   * M20
   * SW1
   *
   * We deliberately do not treat normal numbers as sectors.
   */
  const matches = text.match(
    /\b[A-Z]{1,2}\d{1,2}[A-Z]?\b/g
  );

  if (!matches?.length) {
    return null;
  }

  const sector = normalizeSectorName(
    matches[0]
  );

  return sector || null;
}

// -------------------------------------------------------
// READ PUBLIC SECTOR INTELLIGENCE
// -------------------------------------------------------

export async function getPublicSectorIntel(sector) {
  const normalisedSector =
    normalizeSectorName(sector);

  if (!normalisedSector) {
    return {
      found: false,
      reason: "invalid-sector",
    };
  }

  try {
    const {
      data,
      error,
    } = await supabase.rpc(
      "get_public_sector_intel",
      {
        p_sector: normalisedSector,
      }
    );

    if (error) {
      console.error(
        "[Pat] Sector intelligence RPC failed:",
        error
      );

      return {
        found: false,
        reason: "lookup-failed",
        sector: normalisedSector,
      };
    }

    /*
     * RETURNS TABLE normally comes back
     * as an array from Supabase RPC.
     */
    const row =
      Array.isArray(data)
        ? data[0]
        : data;

    if (!row) {
      return {
        found: false,
        reason: "not-found",
        sector: normalisedSector,
      };
    }

    const households = Number(
      row.household_count
    );

    if (
      !Number.isFinite(households) ||
      households <= 0
    ) {
      return {
        found: false,
        reason: "missing-households",
        sector: normalisedSector,
      };
    }

    const returnedSector =
      normalizeSectorName(
        row.postcode_sector
      ) || normalisedSector;

    return {
      found: true,

      sector:
        returnedSector,

      households,

      price:
        households * 0.01,
    };
  } catch (error) {
    console.error(
      "[Pat] Sector intelligence exception:",
      error
    );

    return {
      found: false,
      reason: "lookup-failed",
      sector: normalisedSector,
    };
  }
}